<template>
  <div class="list_message">
    <div class="top">
      <span class="name">{{record.queristName}}</span>
      <span class="state pending" v-if="record.statue == 1">待处理</span>
      <span class="state processed" v-if="record.statue == 10">已处理</span>
    </div>
    <div class="body">
      <p class="content">
        <span class="title">咨询对象：</span>
        <span class="obj">{{record.advisoryObject}}</span>
      </p>
      <p class="content">
        <span class="title">留言时间：</span>
        <span class="obj">{{record.advisoryTime}}</span>
      </p>
    </div>
    <div class="foot">
      <span  @click="$router.push({path: '/investment/messageDetails',query:{id:record.id}})">查看详情</span>
      <img  @click="$router.push({path: '/investment/messageDetails',query:{id:record.id}})" src="../../../assets/investment/jinru.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "listMessage",
  components: {},
  props: {
    record: {
      id: '',
      advisoryObject: '',
      queristName: '',
      phone: '',
      statue: '',
      statueValue: '',
      operatorName: '',
      qqWechat: '',
      queryContent: '',
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.list_message {
    background: #FFFFFF;
    padding: 12px 20px;
    border-radius: 3px;
    margin-top: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
    .top{
      display: flex;
      justify-content: space-between;
      .name{
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .state{
        margin-left: 20px;
        white-space: nowrap;
        font-size: 12px;
        line-height: 22px;
      }
      .pending{
        color: #36B374;
      }
      .processed{
        color: #999999;
      }
    }
    .body{
      padding-top: 12px;
      border-bottom: 0.5px solid #EEEEEE;

      .content{
        margin-bottom: 12px;
        line-height: 17px;
        color: #333333;
      }
    }
    .foot{
      padding-top: 12px;
      
      span{
        display: inline-block;
        color: #36B374;
        line-height: 17px;
        font-size: 12px;
      }
      img{
        display: inline-block;
        width: 4px;
        height: 8px;
        margin-left: 5px;
      }
    }
}
</style>